import { useMemo } from 'react';

import { useCurrentUser } from '@bonusly/who-am-i';

import { useEvaluation } from '../context';

export const useHeaderText = () => {
	const evaluation = useEvaluation();
	const user = useCurrentUser();

	return useMemo(() => {
		const giver_name = evaluation.giver.name;
		const receiver_name = evaluation.receiver.name;
		let key = 'user_asked';

		if (evaluation.receiverIs(user.id)) {
			key = 'you_asked';
		} else if (evaluation.giverIs(user.id)) {
			key = 'asked_you';
		}

		return {
			giver_name,
			key,
			receiver_name,
		};
	}, [evaluation, user]);
};
